<template>
    <div style="height: 100%; flex-basis: 100%;">
        <Signature
            title="Assinatura Cliente"
            type="client"
            :initial-points="initialClientSignature"
            ref="signature"
        />

        <div class="container-buttons">
            <b-button
                class="mt-3 buttons"
                variant="danger"
                type="button"
                id="clear-button"
                @click="() => {clear();}"
            >
                <img src="@/assets/quizIcons/ic_apagar2.png" width="18" height="18" />
                Limpar
            </b-button>
            <b-button
                class="mt-3 buttons"
                v-b-modal.modal
                id="modal-button"
                variant="primary"
            >
                <img src="@/assets/quizIcons/ic_cliente.png" width="18" height="18" />
                Cliente
            </b-button>

            <b-button
                class="mt-3 buttons"
                variant="success"
                type="button"
                id="save-button"
                @click.stop="nextPhase"
            >
                Próximo
            </b-button>
        </div>

        <b-modal ref="modal" id="modal" title="Informações Cliente" hide-footer>
            <form
                ref="form"
                @submit="validateForm"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
            >
                <b-form-group>
                    <b-form-input
                        maxlength="30"
                        size="30"
                        autocomplete="off"
                        :required="this.clientDataRequired"
                        class="mt-4 form-control"
                        v-model="form.clientFullName"
                        type="text"
                        placeholder="Nome Completo"
                        id="fullName"
                        v-mask="{ regex: '[A-zÀ-ú ]*' }"
                    ></b-form-input>
                    <b-form-input
                        :required="this.clientDataRequired"
                        class="mt-4 form-control"
                        v-model="form.clientRg"
                        type="text"
                        placeholder="RG"
                        id="rg"
                        v-mask="{ regex: '[0-9a-zA-Z]*' }"
                    ></b-form-input>
                    <b-form-input
                        v-mask="{ mask: ['(99) 9999-9999', '(99) 99999-9999'] }"
                        autocomplete="off"
                        :required="this.clientDataRequired"
                        class="mt-4 form-control"
                        v-model="form.clientPhoneNumber"
                        type="tel"
                        placeholder="Telefone"
                        id="phoneNumber"
                    ></b-form-input>
                </b-form-group>
                <b-button class="modalConfirmButton" type="submit" variant="primary"
                    >Confirmar</b-button
                >
            </form>
        </b-modal>
    </div>
</template>

<script>
import { BButton, BModal, BFormInput, BFormGroup, VBModal } from "bootstrap-vue";
import Signature from "@/components/Signature.vue";
import Swal from "sweetalert2";

export default {
    name: "ClientSignature",
    components: {
        Signature,
        BButton,
        BModal,
        BFormInput,
        BFormGroup
    },
    directives: {
        "b-modal": VBModal
    },
    data: function () {
        return {
            clientDataRequired: null,
            form: {
                clientRg: null,
                clientFullName: null,
                clientPhoneNumber: null,
            },
            initialClientSignature: null
        };
    },
    created: function () {
        this.initialClientSignature = this.$store.state.inspectionData.clientSignaturePoints;
    },
    mounted: function () {
        this.carregaParametroDadosObrigatorios();

        this.form.clientRg = this.$store.state.inspectionData.clientRg;
        this.form.clientFullName = this.$store.state.inspectionData.clientFullName;
        this.form.clientPhoneNumber = this.$store.state.inspectionData.clientPhoneNumber;
    },
    methods: {
        clear() {
            this.$refs.signature.clearCanvas();
        },
        validateForm(event) {
            event.preventDefault();
            this.$store.commit("setClientRg", this.form.clientRg);
            this.$store.commit("setClientFullName", this.form.clientFullName);
            this.$store.commit("setClientPhoneNumber", this.form.clientPhoneNumber);
            this.$refs["modal"].hide();
        },
        carregaParametroDadosObrigatorios() {
            const operationParams = this.$store.state.inspectionData.operation.parametros;
            this.clientDataRequired = operationParams["obriga_informe_informacoes_cliente"].ativo;
        },
        saveSignature: async function () {
            let signature = this.$refs.signature;
            const { signaturePoints, signatureURL } = signature.captureSignature();

            if (signaturePoints[0] && signaturePoints[0].points.length > 0) {
                this.$store.commit("setClientSignaturePoints", signaturePoints);

                const clientSignature = {
                    image_base64: signatureURL,
                    image_name: "Cliente",
                };

                const signatures = this.$store.state.inspectionData.signatures;
                signatures.forEach((item, index, object) => {
                    if (item.image_name === "Cliente") {
                        object.splice(index, 1);
                    }
                });

                this.$store.commit("setSignature", clientSignature);

                if (!this.clientDataRequired) {
                    this.$store.commit("setClientSigComplete", true);
                } else if (
                    this.form.clientFullName &&
                    this.form.clientPhoneNumber &&
                    this.form.clientRg
                ) {
                    this.$store.commit("setClientSigComplete", true);
                }
            } else {
                this.$store.commit("setClientSigComplete", false);
                this.$store.commit("setClientSignaturePoints", null);
            }
        },
        nextPhase: function () {
            this.$router.push("/inspection/save-inspection");
        },
    },
    beforeRouteLeave(to, from, next) {
        try {
            this.saveSignature();
        } catch (error) {
            console.error("Erro ao salvar assinatura:", error);
        }

        if (
            (
                this.clientDataRequired &&
                !this.form.clientFullName &&
                !this.form.clientPhoneNumber &&
                !this.form.clientRg
            )
            && to.path.split("/")[1] === "inspection"
        ) {
            next(false);
            Swal.fire({
                icon: "warning",
                title: "Dados do cliente faltando",
                text: "Preencha todos os dados do cliente para continuar.",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Ok",
            });
        } else {
            next();
        }
    },
};
</script>

<style scoped>
    .container-buttons {
        background: linear-gradient(#cdd7d6, white);
        width: 100%;
        position: fixed;
        bottom: 0;
        padding-left: 7%;
        padding-right: 7%;
        padding-bottom: 10px;
        right: 0;
        display: flex;
        justify-content: space-between;
    }

    .buttons {
        float: right;
        width: 100px;
        margin-right: 0;
    }

    .modalConfirmButton {
        float: right;
    }
</style>
